import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e61c9e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row_item_div" }
const _hoisted_2 = ["onClick"]

import { SHAPE_LIST, ShapePoolItem } from '@/configs/shapes'
import ShapeItemThumbnail from './ShapeItemThumbnail.vue'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'ShapeStack',
  emits: ["select"],
  setup(__props, { emit }: { emit: ({
  (event: 'select', payload: ShapePoolItem): void
}), expose: any, slots: any, attrs: any }) {

const { t, locale } = useI18n()



const selectShape = (shape: ShapePoolItem) => {
  emit('select', shape)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SHAPE_LIST), (item) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "item_div",
      key: item.type
    }, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t(item.type)), 1),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (shape, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "stack_div",
            key: index,
            onClick: ($event: any) => (selectShape(shape))
          }, [
            _createVNode(ShapeItemThumbnail, {
              class: "shape-item",
              shape: shape
            }, null, 8, ["shape"])
          ], 8, _hoisted_2))
        }), 128))
      ])
    ]))
  }), 128))
}
}

})